import React from "react";
import { useAudioSystem } from "../context/AudioContext";
import { Minus, Plus, VolumeX, Volume2 } from "lucide-react";

export default function VolumeControl() {
  const { masterVolume, muted, changeVolume, toggleMute } = useAudioSystem();

  return (
    <div className="bg-[#18181B] border border-white/10 rounded-2xl p-5">
      <h2 className="font-display font-black text-xl tracking-tight text-[#00F0FF] neon-glow-blue mb-4">
        MASTER VOLUME
      </h2>
      <div className="flex items-center gap-4 mb-4">
        <button
          data-testid="volume-down"
          onClick={() => changeVolume(masterVolume - 5)}
          className="w-20 h-20 rounded-xl bg-[#27272A] hover:bg-[#3f3f46] active:scale-95 transition-transform duration-75 flex items-center justify-center"
        ><Minus className="w-10 h-10 text-white" /></button>

        <div data-testid="volume-value" className="flex-1 text-center">
          <div className={`font-display font-black text-5xl ${muted ? "text-[#FFCC00]" : "text-white"}`}>
            {muted ? "MUTE" : `${masterVolume}%`}
          </div>
        </div>

        <button
          data-testid="volume-up"
          onClick={() => changeVolume(masterVolume + 5)}
          className="w-20 h-20 rounded-xl bg-[#27272A] hover:bg-[#3f3f46] active:scale-95 transition-transform duration-75 flex items-center justify-center"
        ><Plus className="w-10 h-10 text-white" /></button>
      </div>

      <button
        data-testid="mute-all"
        onClick={toggleMute}
        className={`w-full h-16 rounded-xl font-display font-black text-lg tracking-wide flex items-center justify-center gap-3 active:scale-95 transition-transform duration-75 ${
          muted ? "bg-[#FFCC00] text-black" : "bg-[#27272A] text-white border border-white/10"
        }`}
      >
        {muted ? <Volume2 className="w-7 h-7" /> : <VolumeX className="w-7 h-7" />}
        {muted ? "UNMUTE ALL" : "MUTE ALL"}
      </button>
    </div>
  );
}
